import type { LatestBrandRelease } from './latestReleases';

export const currentBrandReleases: LatestBrandRelease[] = [
  {
    "id": "book-9786264710619",
    "title": "人體自癒療法，按下身體的修復鍵：90％的疾病可治癒！",
    "subtitle": "【免疫、防禦、再生、情緒、習慣】 總是疲累、反覆生病、恢復得比別人慢",
    "author": "楊爍 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-11-04",
    "isbn": "9786264710619",
    "coverImage": "/assets/books/9786264710619.jpg",
    "summary": "【免疫、防禦、再生、情緒、習慣】 總是疲累、反覆生病、恢復得比別人慢？ 問題可能不只是疾病本身，而是身體的自我修復力正在下降 從免疫力到腸道健康，從飲食運動到中醫調養 ──學會聽懂身體訊號，讓健康不再只靠生病後補救！ ▎身體，其實一直在努力治好自己 當皮膚受傷，傷口會慢慢癒合；當感冒來襲，身體會啟動免疫反應；當疲勞累積，我們會自然產生睡意，提醒自己需要休息。這些看似理所當然的現象，其實都來自人體與生俱來的「自癒力」。本書正是從這股隱藏在身體深處的力量出發，帶領讀者重新認識自己的身體，了解免疫、防禦、修復、代謝與內分泌系統如何相互合作，讓身體在受到傷害後，一步步恢復平衡。自癒不是神奇療法，而是人體每天都在進行的生命工程。 ▎真正的健康"
  },
  {
    "id": "book-9786264710589",
    "title": "做自己的醫生（生理篇）：環境毒素、飲食失衡、生活習慣，健康亮紅燈該怎麼辦？",
    "subtitle": "環境×飲食×生活習慣 減少負擔，重新關注身體訊號 認識自己，每一天都為健康多做一份準備 ▎從疾病增加的現象，重新思考我們的生活 醫療科技不斷進步，人類的壽命持續延長，慢性病、自體免疫性疾病、失智症、憂鬱症、過敏與營養代謝問題卻愈來愈普遍",
    "author": "張文莉 Dr.A.Z",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-11-04",
    "isbn": "9786264710589",
    "coverImage": "/assets/books/9786264710589.jpg",
    "summary": "環境×飲食×生活習慣 減少負擔，重新關注身體訊號 認識自己，每一天都為健康多做一份準備 ▎從疾病增加的現象，重新思考我們的生活 醫療科技不斷進步，人類的壽命持續延長，慢性病、自體免疫性疾病、失智症、憂鬱症、過敏與營養代謝問題卻愈來愈普遍。本書從全球健康現況出發，帶領讀者檢視現代生活與疾病之間的關係。科技替生活帶來便利，也使久坐、睡眠不足、心理壓力與環境暴露成為日常；工業化食品、現代農業與漫長的食物供應鏈，也悄悄改變我們吃進身體的東西。 ▎找出藏在生活裡的健康風險 許多人明明經常疲倦、疼痛、失眠、過敏或精神不濟，接受檢查後卻被告知一切正常。本書以「冰山效應」說明疾病形成前的累積過程：水面上看得到的是已經被診斷的疾病，水面下則可能存在長"
  },
  {
    "id": "book-9786264074773",
    "title": "古代外交：歷代外交與文化交流",
    "subtitle": "外交不僅是言辭的交鋒，更是一國生存興衰與文明擴張的縮影",
    "author": "肖東發 主編，王金鋒 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "歷史",
    "publishDate": "2026-11-04",
    "isbn": "9786264074773",
    "coverImage": "/assets/books/9786264074773.jpg",
    "summary": "外交不僅是言辭的交鋒，更是一國生存興衰與文明擴張的縮影。 本書將視角置於綿延數千年的東亞文明史中，有系統地勾勒自上古列國紛爭至近世國門半開的交涉歷程。 從春秋戰國諸侯割據時期的合縱連橫、遠交近攻等智謀較量，到秦漢帝國開闢陸海通道、廣通西域與周邊邦國的宏偉開局，外交在實力消長與利益權衡中逐步奠定版圖秩序。 隨著隋唐繁盛時期的文化輸出與跨國商貿頻繁往來，乃至宋元海路貿易的繁榮與明代萬國來朝的朝貢盛景，對外往來始終牽動著內政變革與經濟命脈。 進入近世清代，面對逐漸變動的全球局勢，傳統體系亦在守成與調適之間經歷激盪。本書依循嚴謹的歷史脈絡，立體呈現各個歷史節點中的決策情境、博弈智慧與文化融合軌跡。 讀者將能從歷朝歷代的攻守進退中，釐清古代邦"
  },
  {
    "id": "book-9786264284745",
    "title": "國民政府不願提的北洋十六年：軍閥大亂鬥！從洪憲帝制、府院之爭、張勳復辟到直奉角力，十位北洋大帥如何結盟、翻臉、崛起與殞落",
    "subtitle": "袁世凱、馮國璋、段祺瑞、黎元洪、吳佩孚、張作霖…… 從總統、督軍到大元帥， 十位北洋人物的發跡之路、政治手腕與成敗抉擇 【北洋十六年，權力重組下的風雲時代】 從清末帝制崩解到民國初建，中國進入一段政局劇烈變動的北洋時代",
    "author": "劉嘯虎",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "歷史",
    "publishDate": "2026-11-04",
    "isbn": "9786264284745",
    "coverImage": "/assets/books/9786264284745.jpg",
    "summary": "袁世凱、馮國璋、段祺瑞、黎元洪、吳佩孚、張作霖…… 從總統、督軍到大元帥， 十位北洋人物的發跡之路、政治手腕與成敗抉擇 【北洋十六年，權力重組下的風雲時代】 從清末帝制崩解到民國初建，中國進入一段政局劇烈變動的北洋時代。袁世凱建立新軍、掌握北洋勢力，並在清廷與共和之間完成權力轉換；其後，各派軍政人物相繼崛起，在中央與地方、共和與復辟、統一與割據之間反覆角力。這段歷史過去常被概括為「北洋軍閥時代」，但其中的人物與局勢其實遠比「軍閥混戰」四字複雜。本書從人物出發，重新梳理北洋政治集團的形成、分化與消長，看十六年間權力如何轉移、派系如何聚散，以及一批出身、性格、選擇截然不同的人物，如何一步步走上政治舞 臺 。 【從袁世凱到段祺瑞，看北洋核"
  },
  {
    "id": "book-9786264074759",
    "title": "官學盛況：國子監與學宮的教育",
    "subtitle": "中國古代官學體系自先秦萌芽至明清完備，是推行儒學教化與選拔治國人才的核心制度",
    "author": "肖東發 主編，董勝 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "歷史",
    "publishDate": "2026-11-04",
    "isbn": "9786264074759",
    "coverImage": "/assets/books/9786264074759.jpg",
    "summary": "中國古代官學體系自先秦萌芽至明清完備，是推行儒學教化與選拔治國人才的核心制度。本書跳脫生硬條文，以地理空間與古建築為經緯，平實梳理中央至地方官學的運作脈絡。 全書系統性記錄元明清北京國子監的營建規制與管理、南京夫子廟與江南貢院的科舉樞紐角色，並上溯稷下學宮等早期學宮源流，更深入剖析揭陽、德慶等廣東學宮群落，呈現儒學向嶺南扎根的歷程。融匯制度史與建築文化，完整勾勒古代官學教育的真實圖景。 本書特色： 本書立足於深厚史料，以地理空間為脈絡，全景透視北京、南京及嶺南等地的學宮與最高學府國子監。 全文 兼顧制度演變與建築格局，詳述古代中央與地方官學的興衰、科舉考試運作及尊儒傳統，引領讀者深刻理解儒家教化如何深植中國社會與官僚體系，是兼具可讀"
  },
  {
    "id": "book-9786264085779",
    "title": "官（職）場必學的藏鋒智慧《韜晦術》：隱晦×養晦×謀晦×用晦……從王守仁、謝安到朱元璋、劉秀，看藏鋒避禍如何成為成事之術",
    "subtitle": "從藏鋒到用晦，亂世中的處世學 ── 《韜晦術》",
    "author": "楊慎 原著，楊明剛 注譯",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "商業理財",
    "publishDate": "2026-11-04",
    "isbn": "9786264085779",
    "coverImage": "/assets/books/9786264085779.jpg",
    "summary": "從藏鋒到用晦，亂世中的處世學 ── 《韜晦術》！ 八卷梳理隱晦、處晦、養晦與用晦之道， 看歷代人物如何藏鋒、避禍與等待時機 【藏鋒守晦，在進退之間保全自己】 真正高明的處世智慧，往往不在於處處顯露才華，而在於懂得何時收斂鋒芒、保存實力。 本書 以「韜光養晦」為核心，從歷代人物的成敗得失出發，探討人在權力、名聲、利益與危機交錯的環境中，如何審時度勢、隱藏真實意圖，避免因一時逞強而招致禍患。全書首先從「隱晦」 、 「處晦」 、 「養晦」談起，以楚莊王、徐階、解縉、王守仁、宋文帝、王導、朱權、韓世忠等人的經歷，呈現才華、功名與權勢背後的風險。有人因懂得隱忍而等待到施展抱負的時機，也有人因鋒芒過露、未能 拿捏 進退 分寸 而招致猜忌。從這些"
  },
  {
    "id": "book-9786264085786",
    "title": "江恩讀盤新解，百年投資經典現代重編：台股、美股與商品期貨實例，帶你掌握價格變化背後的市場訊息",
    "subtitle": "某檔股票突然變熱門，但你真的知道它在受到關注之前的變化嗎",
    "author": "[美]威廉．江恩（William D.Gann）著 伊莉莎工作室 編譯",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "商業理財",
    "publishDate": "2026-11-04",
    "isbn": "9786264085786",
    "coverImage": "/assets/books/9786264085786.jpg",
    "summary": "某檔股票突然變熱門，但你真的知道它在受到關注之前的變化嗎？ 行情越熱，越要先看清這段漲幅是從哪裡開始的 從市場紀錄判斷趨勢與轉折，學會部位管理與風險控制！ 【從讀盤認識市場】 1923年的交易者透過行情紙帶追蹤市場，今天的投資人則面對即時報價、逐筆成交、新聞與各式圖表。工具雖然不同，但真正處理的仍然是價格、成交與時間留下的紀錄。本書先從讀盤的基本觀念開始，說明哪些數字代表已完成交易，哪些仍是等待中的申報，再進一步談成交量應如何和個股自身的歷史相比，以及不同觀察期間會得到哪些不同結果。面對熱門股票、新聞與社群討論，讀者也能逐步分清市場熱度、企業成果與價格表現之間的差別。 【掌握趨勢與轉折】 市場是從一段時間內的高低點、成交活動與價格推"
  },
  {
    "id": "book-9786264284738",
    "title": "皇位有毒！大唐天子全員求生中：安史兵火、朋黨傾軋、藩鎮割據……從繁華巔峰走向四方離心，讀懂二十位皇帝的盛世、亂局與危機",
    "subtitle": "【玄宗】曾把大唐推上巔峰，又把局勢拉回谷底 【憲宗】用計漂亮打壓藩鎮，卻沒防住身邊宦官 【敬宗】上朝",
    "author": "楊明之",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "歷史",
    "publishDate": "2026-11-04",
    "isbn": "9786264284738",
    "coverImage": "/assets/books/9786264284738.jpg",
    "summary": "【玄宗】曾把大唐推上巔峰，又把局勢拉回谷底 【憲宗】用計漂亮打壓藩鎮，卻沒防住身邊宦官 【敬宗】上朝？晚一點再說！踢球摔跤不能缺席 【武宗】削藩、抑宦、滅佛，最後栽在長生丹藥 二十位帝王，撐起大唐近三百年的盛世與危局 從權力巔峰到王朝傾覆，每一次選擇都在改寫帝國命運 ▎盛世的形成，從來不是偶然 從唐高祖李淵建立政權，到唐太宗李世民開創貞觀之治，唐朝在制度、軍事、用人與國家治理上逐步建立起強盛格局。高宗、武周以後，權力結構持續調整，至玄宗前期又迎來開元盛世。然而，帝國的繁榮背後始終存在著皇權、外戚、宦官、藩鎮與朝臣之間的角力。當君主能夠駕馭群臣、整合資源，國家便能維持秩序；當權力失去平衡，再繁華的局面也可能迅速出現裂痕。唐朝近三百年的"
  },
  {
    "id": "book-9786264074766",
    "title": "科技首創：萬物探索與發明發現",
    "subtitle": "多少文明發展自土地，多少人民接受過大地的贈與；生活中的點點滴滴，都 是世界的饋贈",
    "author": "肖東發 主編，李奎 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "歷史",
    "publishDate": "2026-11-04",
    "isbn": "9786264074766",
    "coverImage": "/assets/books/9786264074766.jpg",
    "summary": "多少文明發展自土地，多少人民接受過大地的贈與；生活中的點點滴滴，都 是世界的饋贈。 人類的智慧將大地的恩賜轉化為卓越的成就，成長為今日的風貌。 利民生存，環境共生；代代傳承，不斷進步。 想過日常用品是怎麼來的嗎？想知道交通建設是怎麼發展起來的嗎？ 可還記得中國醫道曾在誕生的土地上一枝獨秀的輝煌歲月？ 除了火藥，誰還能細數中國有多少兵器曾在戰場上展現過驚人威力？ 科技的發展向來不是史書的重點，卻是建立王朝的重心。 中國兩千多年的歷史演變與驚人的人口總數，給足科技發展的時間、空間與人力，創造無數傑出的成就，帶給古人與後世充分的便利。歷史的長河縝密地記錄這些文物的發展，在驚嘆擁有這些便利的現在，不妨一起探尋那些演變的過去。 本書特色： 本"
  },
  {
    "id": "book-9786267165607",
    "title": "管得少，團隊越好：團隊風險指數！超速凝聚高效團隊力，攜手破解企業信任危機",
    "subtitle": "別讓好員工寒心",
    "author": "楊仕昇，朱明岩",
    "brand": "清文華泉",
    "brandSlug": "qinghua-wenquan",
    "category": "商業理財",
    "publishDate": "2026-11-04",
    "isbn": "9786267165607",
    "coverImage": "/assets/books/9786267165607.jpg",
    "summary": "別讓好員工寒心！主管必修的管理溝通課 公平用人×坦誠溝通×充分授權…… 放下過度控制，打造屬於你的高凝聚力團隊！ 【看不見的信任危機】 企業內部一旦失去信任，影響的不只是人際關係，還可能動搖整體經營。主管任人唯親、承諾反覆、賞罰不公，容易使員工從積極投入轉為消極觀望，部門間也逐漸出現隔閡，進而引發派系鬥爭、爭功卸責等問題。若老闆又習慣事必躬親、越級指揮，甚至將錯誤推給下屬，中階主管往往有責無權，難以協調工作。這些看似細微的問題日積月累，將形成嚴重的內耗，拖慢決策、削弱執行力，甚至造成優秀人才流失。 【從控制部屬到凝聚人心】 建立信任，需要領導者先檢視自己的管理方式。是否願意信守承諾、承認過失？能否公平對待員工，並耐心聽取不同意見？本"
  },
  {
    "id": "book-9786264710596",
    "title": "虢國夫人遊春圖，盛唐仕女、名馬與宮廷生活：衣冠髮式×人物關係×馬匹步態×收藏題跋，細讀畫中蛛絲馬跡，追尋人物身分、創作年代與傳世歷程",
    "subtitle": "畫中九人八騎，看似春日出遊，誰才是真正的虢國夫人",
    "author": "黃小峰",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "人文社科",
    "publishDate": "2026-11-04",
    "isbn": "9786264710596",
    "coverImage": "/assets/books/9786264710596.jpg",
    "summary": "畫中九人八騎，看似春日出遊，誰才是真正的虢國夫人？ 那些看似尋常的服飾、髮髻與馬匹，為何透露出不同時代的痕跡？ 【一幅名畫，藏著盛唐世界的縮影】 一隊春日出遊的人馬，衣飾華美、步履從容，看似只是貴族女性遊春的瞬間，卻在千年流轉中承載了遠比畫面更複雜的歷史訊息。〈虢國夫人遊春圖〉傳為唐代張萱所作，現存卷本通常被視為宋代摹本。畫中人物究竟誰是虢國夫人？男裝女子、女童、侍從如何辨認？三鬃馬、斑毛馬與不同步態又透露出哪些時代特徵？從人物身分到服飾制度，從宮廷生活到騎乘文化，一幅畫由此成為重新理解盛唐社會的入口。 【從細節辨識畫中的真實年代】 畫面中的一頂幞頭、一件襴袍、一枚團窠紋樣，乃至髮髻、腰帶、馬具，都可能成為判斷作品年代的重要線索。透"
  },
  {
    "id": "book-9786264074780",
    "title": "貨幣歷程：歷代貨幣與錢幣形式",
    "subtitle": "一枚方孔錢，如何牽動兩千年的帝國興衰",
    "author": "肖東發 主編，楊宏偉 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "歷史",
    "publishDate": "2026-11-04",
    "isbn": "9786264074780",
    "coverImage": "/assets/books/9786264074780.jpg",
    "summary": "一枚方孔錢，如何牽動兩千年的帝國興衰？ 從貝幣、刀布到秦始皇定型「外圓內方」的半兩錢； 從北宋益州誕生世界第一張紙幣「交子」，到明清銀本位與印鈔技術的演革 貨幣不僅是交易的媒介，更是政權存續、國家法令與社會繁榮的縮影。 本書 依循貨幣的形制演進與制度發展為主線 ， 結合理論制度、出土文物與歷史脈絡，不僅為讀者還原歷代錢幣的誕生背景，更揭示出貨幣在政治權力、民生賦稅與商業流通間的深層連動，是理解中國古代經濟與社會生活演變的絕佳指南。 本書特色： 全書跳脫繁雜枯燥的斷代年表，聚焦中國古代貨幣「形態演變」的核心軌跡。系統梳理秦統一度量到方孔半兩、漢代五銖錢制度確立，再到宋元明清紙幣交子、大明寶鈔與白銀流通，透視歷代王朝在金融制度、鑄造技術"
  },
  {
    "id": "book-9786264710602",
    "title": "龍膽瀉肝湯：肝膽溼熱良方",
    "subtitle": "清瀉肝膽、清利溼熱、兼顧疏肝養血 深入解析經典名方「龍膽瀉肝湯」 從方源考辨、類方辨析到分科臨證與現代藥理研究 完整掌握龍膽瀉肝湯的組方理論、臨床應用與研究進展 【經方出處與歷代方論】 龍膽瀉肝湯為中醫常用經典方劑，其出處歷來有不同說法",
    "author": "楊建宇，祁爍，劉華寶 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-11-04",
    "isbn": "9786264710602",
    "coverImage": "/assets/books/9786264710602.jpg",
    "summary": "清瀉肝膽、清利溼熱、兼顧疏肝養血 深入解析經典名方「龍膽瀉肝湯」 從方源考辨、類方辨析到分科臨證與現代藥理研究 完整掌握龍膽瀉肝湯的組方理論、臨床應用與研究進展 【經方出處與歷代方論】 龍膽瀉肝湯為中醫常用經典方劑，其出處歷來有不同說法。本書上篇首先從經方出處、方名釋義、藥物組成、使用方法與方歌著手，考察《蘭室祕藏》、《東垣試效方》、《醫方集解》等相關文獻，梳理本方的形成與傳承脈絡，並輯錄歷代醫家對龍膽瀉肝湯的代表性論述。書中另整理瀉青丸、當歸龍薈丸等相關類方，從組成、功效與適用病證進行比較，使讀者掌握不同方劑之間的配伍特色與運用差異。 【清瀉肝膽配伍特色】 在方藥解析方面，本書以龍膽草、黃芩、梔子、澤瀉、木通、車前子、當歸、生地黃"
  },
  {
    "id": "book-9786269339358",
    "title": "普洱入門，時間留下的味道：從生熟之分到陳化判斷，建立選茶、存茶與品飲的基本觀念",
    "subtitle": "從一餅茶的滋味，看見普洱百年流轉的歷史、市場與價值變化 讀懂古樹、拼配、倉儲與投資熱潮，回歸普洱茶的品飲本質 【從一餅茶，看懂普洱的歷史與市場】 普洱茶不只是雲南的一種地方茶，也是一個跨越產區、工藝、",
    "author": "笨泥",
    "brand": "策點文化",
    "brandSlug": "cedian-culture",
    "category": "飲食",
    "publishDate": "2026-10-29",
    "isbn": "9786269339358",
    "coverImage": "/assets/books/9786269339358.jpg",
    "summary": "從一餅茶的滋味，看見普洱百年流轉的歷史、市場與價值變化 讀懂古樹、拼配、倉儲與投資熱潮，回歸普洱茶的品飲本質 【從一餅茶，看懂普洱的歷史與市場】 普洱茶不只是雲南的一種地方茶，也是一個跨越產區、工藝、倉儲、品牌與消費文化的特殊市場。從昆明、勐海、下關三家茶廠的發展，到香港倉儲、臺灣茶商與中國大陸市場的相互影響，普洱茶在數十年間完成了由區域性商品走向大眾消費品與收藏標的的轉變。本書沿著產業演變的脈絡，說明普洱茶如何被生產、流通與定價，又如何在一次次市場起落中，形成今日獨特的價值判斷方式。 【乾倉、港倉與越陳越香】 普洱茶最受矚目的特質，在於茶葉會隨時間與存放環境持續轉化。然而，「越陳越香」並不代表任何茶只要久放就會變好。原料品質、製作"
  },
  {
    "id": "book-9786264710411",
    "title": "六味地黃丸：滋陰補腎名方",
    "subtitle": "滋陰補腎、三補三瀉、調和肝脾腎 深入解析經典名方「六味地黃丸」 從方名源流、類方辨析到分科臨證與現代藥理研究 完整掌握六味地黃丸的組方理論、臨床應用與研究進展 【溯本求源，釐清方名與經方源流】 六味地",
    "author": "楊建宇，童安榮，鄭佳新 主編",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-28",
    "isbn": "9786264710411",
    "coverImage": "/assets/books/9786264710411.jpg",
    "summary": "滋陰補腎、三補三瀉、調和肝脾腎 深入解析經典名方「六味地黃丸」 從方名源流、類方辨析到分科臨證與現代藥理研究 完整掌握六味地黃丸的組方理論、臨床應用與研究進展 【溯本求源，釐清方名與經方源流】 六味地黃丸源自宋代錢乙《小兒藥證直訣》所載「地黃丸」，後經歷代醫家傳承與發展，逐漸形成今日通行的六味地黃丸。本書上篇首先從經方出處、方名釋義、藥物組成、使用方法與方歌著手，梳理本方的形成脈絡與命名由來，並輯錄歷代醫家對本方的代表性論述。書中特別說明地黃丸與腎氣丸之間的源流關係，以及「六味」一名的歷史演變與理論意涵，使讀者從方名、組方到方義逐步理解六味地黃丸的發展。另整理杞菊地黃丸、麥味地黃丸、知柏地黃丸、七味都氣丸、耳聾左慈丸、左歸丸、右歸丸"
  },
  {
    "id": "book-9786264710466",
    "title": "別急著吃藥！實用中醫妙方：內科×外科×婦兒×美容保健……彙整古今驗方、祕方與食療，完整呈現傳統調養的多樣面貌",
    "subtitle": "認識藥材性味，掌握煎服方法，避開常見誤區 小方妙用，帶你認識傳統養生智慧的基本觀念！",
    "author": "牛豔飛 整理",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-28",
    "isbn": "9786264710466",
    "coverImage": "/assets/books/9786264710466.jpg",
    "summary": "認識藥材性味，掌握煎服方法，避開常見誤區 小方妙用，帶你認識傳統養生智慧的基本觀念！ 【掌握居家煎藥的關鍵細節】 中藥湯劑看似只是加水煎煮，其中卻包含器皿選擇、用水方式、浸泡時間、火候控制與煎煮次數等重要知識。本書以居家操作為核心，從適合使用的砂鍋、陶瓷鍋與不鏽鋼鍋談起，說明不同材質可能對藥效造成的影響，並解析加水量、水質及先浸後煎的實用原則。讀者可循序了解武火與文火的運用、各類藥材所需的煎煮時間，以及如何從藥材狀態、氣味與藥液濃度判斷是否煎透。針對藥液煎乾、藥材焦煳等常見失誤，書中亦提供預防方法與安全處理原則，幫助讀者避免因操作不當而影響品質。 【建立正確而安心的服藥觀念】 藥煎得恰當，還須服用得法，才能兼顧療效與安全。本書進一步"
  },
  {
    "id": "book-9786264074469",
    "title": "創始發明：四大發明與歷史價值",
    "subtitle": "一張紙、一頁印版、一枚磁針、一撮火藥 如何撼動全球文明的走向？",
    "author": "肖東發 主編，鍾雙德 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-28",
    "isbn": "9786264074469",
    "coverImage": "/assets/books/9786264074469.jpg",
    "summary": "一張紙、一頁印版、一枚磁針、一撮火藥 如何撼動全球文明的走向？ ▎ 在人類文明的漫長演進中，「造紙術、印刷術、指南針、黑火藥」並不僅是教科書上標誌輝煌的四個名詞，更是從日常工藝、思想傳播到跨洋探索與軍事革新的技術革命。然而，紙張真的是蔡倫憑空創造的嗎？羅盤如何從方士案頭的「司南」走向遠洋探險？煉丹爐裡意外誕生的黑色火藥，又是怎樣重塑了歐亞大陸的戰爭格局？ ▎ 本書揚棄零碎枯燥的條目羅列，以宏觀的歷史脈絡與嚴謹的考古實證，全面解構四大發明的誕生與流變。全書依時代縱深劃分四大篇章，從西漢灞橋紙的纖維殘片到畢昇活字版的工藝突破，生動重現古代工匠在材料、化學與力學上的智慧結晶；更跨越地域疆界，深刻剖析這些東方發明如何沿著絲綢之路與海洋商道西"
  },
  {
    "id": "book-9786267165584",
    "title": "創意啟動，重拾靈感！崩解慣性思維（修訂版）：你不是缺少創意，只是靈感迷路了",
    "subtitle": "一次偶然的嘗試，也可能帶來意想不到的改變 擺脫思維定式，找回無限創意！",
    "author": "劉惠丞，楊忠",
    "brand": "清文華泉",
    "brandSlug": "qinghua-wenquan",
    "category": "商業理財",
    "publishDate": "2026-10-28",
    "isbn": "9786267165584",
    "coverImage": "/assets/books/9786267165584.jpg",
    "summary": "一次偶然的嘗試，也可能帶來意想不到的改變 擺脫思維定式，找回無限創意！ 好奇心×觀察力×行動力……讓你的靈感重新上路 【打破慣性，重新看見可能】 習慣、成見與對權威的依賴，往往限制了人們的思考。本書從日常心理與思維盲點出發，引導讀者質疑既定觀念、培養獨立判斷的能力，並在嘗試與犯錯中尋找新的方向。書中穿插火車、保溫瓶、電燈等發明故事，說明許多創意如何從不同的提問方式、意外發現與反覆試驗中產生。當既有經驗無法解決問題時，試著改變思考角度，便可能找到新的答案。 【喚醒心智，挖掘內在潛能】 創造力的培養，需要興趣、好奇心、觀察力與持續行動。本書透過具體案例與思維練習，引導讀者擴展興趣、善用感官、鍛鍊意志，逐步培養解決問題的能力。同時，探討權"
  },
  {
    "id": "book-9786264074445",
    "title": "太平盛世：歷代盛世與開明之治",
    "subtitle": "▎ 盛世從非天降，而是刀鋒邊緣的極限突圍！",
    "author": "肖東發 主編，杜友龍 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-28",
    "isbn": "9786264074445",
    "coverImage": "/assets/books/9786264074445.jpg",
    "summary": "▎ 盛世從非天降，而是刀鋒邊緣的極限突圍！ ▎ 中國三千年興衰史中，王朝崩解是常態，但為何夏少康能憑一成之地復國中興？漢文景、唐貞觀又如何從戰後荒蕪中走出治世奇蹟？本書精選歷代二十一場關鍵「盛世」與「中興」，不只講王圖霸業，更深入剖析民心向背、用人布局與制度革新。這不僅是一部波瀾壯闊的通史盛宴，更是現代人在順境鞏固根基、逆境絕地翻盤的經世大戰略！ 本書特色： 本書精選夏商周、兩漢、隋唐、兩宋至明清等關鍵中興與鼎盛時代。以朝代時序為經、帝王經世方略為緯，深刻剖析歷代君主如何凝聚民心、力行改革並逆轉頹局。兼具宏觀通史視野與微觀治國智慧，是讀者縱覽中華文明興衰起伏、借鏡開明之治的必備經典讀本。"
  },
  {
    "id": "book-9786264710428",
    "title": "常見病可以靠點穴治療！常氏點穴式療法：精準取穴×穴位配伍×辨證施術×筋傷調治……結合藥酒火功與禪指揉藥的傳統點穴實用指南",
    "subtitle": "從關鍵力學點、穴位配伍到施術手法， 完整呈現常氏點穴的傳承、操作、傷筋及常見病治療的實用方法 【家傳點穴技法，整理一脈臨床經驗】 常氏點穴療法源自劉振華家傳點穴技法，1970年代由常發祥拜師學習，在長",
    "author": "康獻勇，常宇",
    "brand": "崧燁文化",
    "brandSlug": "songye-culture",
    "category": "醫療保健",
    "publishDate": "2026-10-28",
    "isbn": "9786264710428",
    "coverImage": "/assets/books/9786264710428.jpg",
    "summary": "從關鍵力學點、穴位配伍到施術手法， 完整呈現常氏點穴的傳承、操作、傷筋及常見病治療的實用方法 【家傳點穴技法，整理一脈臨床經驗】 常氏點穴療法源自劉振華家傳點穴技法，1970年代由常發祥拜師學習，在長年臨床實踐中持續整理、研究與改良，逐步形成具有自身特色的治療體系。由於原有技法多靠口傳心授，缺乏完整文字資料，常發祥在掌握家傳要點後，不僅延續原有點穴方法，也改良「火功」，並創立「禪指揉藥」，使點穴、藥酒火功與揉藥技法相互配合。同時，他依據實際施術經驗繪製穴位圖譜，使穴位位置、操作方式與臨床應用更加清楚。本書即是在其口述與弟子多年整理下，將過去較少公開的技法系統化呈現，保存一套具有傳承特色的點穴經驗。 【從穴位、取穴到辨證，建立完整基礎"
  },
  {
    "id": "book-9786264074452",
    "title": "教化於民：太學文化與私塾文化",
    "subtitle": "太學，是古代官立的高等學府，是以傳授、研習儒家經典為主的國立大學。",
    "author": "肖東發 主編，李勇 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-28",
    "isbn": "9786264074452",
    "coverImage": "/assets/books/9786264074452.jpg",
    "summary": "太學，是古代官立的高等學府，是以傳授、研習儒家經典為主的國立大學。夏商周時期已有太學雛形，但太學的制度化始於漢武帝時。漢武帝以儒學為官方思想，其崇儒的具體措施或表現就是設太學，從此揭開了太學的新篇章。 中國古代太學在長期的發展演變中，自漢代至清代末期，其間雖屢遭戰亂停辦，但天下安定則屢次重建，綿延近兩千年，培養了大批人才。 本書特色： 本書以宏觀視野完整梳理古代中國教育脈絡，首創「雙軌對照」架構：上編深入剖析從夏商周太學雛形、漢代太學制度化到明清國子監之中央官學演進；下編生動勾勒孔子講學以降至明清鄉野私塾的庶民講學風貌。官私並陳、制度與文化兼備，全方位揭示華夏文明如何透過「教化於民」傳承千載道統與士林精神。"
  },
  {
    "id": "book-9786264284646",
    "title": "藏在歷史裡的失落之物：琥珀屋×印加寶藏×納粹黃金×沙皇珍寶，追查戰爭、帝國與古文明遺留的財富線索",
    "subtitle": "有些歷史寫在書裡，有些歷史埋在黃金下面 離奇的傳說、稀少的線索、前仆後繼的探索者 走遍荒野與古墓，尋找十五樁未解寶藏之謎 ▎追尋消失在歷史深處的寶藏 寶藏之所以令人著迷，往往不只因為黃金、珠寶與王室財",
    "author": "馬季",
    "brand": "複刻文化",
    "brandSlug": "fuke-culture",
    "category": "人文社科",
    "publishDate": "2026-10-28",
    "isbn": "9786264284646",
    "coverImage": "/assets/books/9786264284646.jpg",
    "summary": "有些歷史寫在書裡，有些歷史埋在黃金下面 離奇的傳說、稀少的線索、前仆後繼的探索者 走遍荒野與古墓，尋找十五樁未解寶藏之謎 ▎追尋消失在歷史深處的寶藏 寶藏之所以令人著迷，往往不只因為黃金、珠寶與王室財富，更因為它們承載著戰爭、權力、宗教與文明興衰的痕跡。本書以考古發現、歷史文獻與流傳至今的傳說為基礎，精選十五樁橫跨歐洲、亞洲、非洲與美洲的著名寶藏謎案，重新梳理它們的來歷、消失經過與後世追尋的線索。那些埋藏於地下、沉沒於海中，或在戰火與政權更替中失去蹤影的珍寶，也成為人們重新理解古代文明的重要入口。 ▎王室珍藏與古代文明的遺產 有些寶藏，記錄的是昔日王朝最鼎盛的時刻。古埃及法老圖坦卡門墓中出土的大量陪葬品，讓世人得以窺見古埃及王權、宗"
  },
  {
    "id": "book-9786264074476",
    "title": "變法圖強：歷代變法與圖強革新",
    "subtitle": "管仲的改革，讓孔子大讚：「微管仲，吾其被髮左衽矣。",
    "author": "肖東發 主編，杜友龍 編著",
    "brand": "千華駐科技",
    "brandSlug": "qianhua-tech",
    "category": "人文社科",
    "publishDate": "2026-10-28",
    "isbn": "9786264074476",
    "coverImage": "/assets/books/9786264074476.jpg",
    "summary": "管仲的改革，讓孔子大讚：「微管仲，吾其被髮左衽矣。」 商鞅變法，讓秦朝一躍成為七國之首，最終得以統一天下。 孝文帝實行漢化，讓在軍事、經濟、文化和政治方面都出現了巨大的進步。 王安石變法失敗，導致北宋長期陷入黨爭。 張居正的改革，在他死後即徹底覆滅，還禍及子孫。 康有為、梁啟超戊戌變法失敗，直接讓清朝改朝換代。 中國漫長歷史中，發生過無數次體制上的變革。本書以時間次序排列，讓讀者能夠逐一了解，中國歷史上，那些曾經試著勵精圖治、又或者想要力挽狂瀾的改革。 本書特色： 本書橫跨春秋戰國至晚清，按朝代時序嚴選商鞅變法、王安石變法、張居正改革及戊戌變法等關鍵體制變革。深入剖析各時期改革家如何於內憂外患中破舊立新、力挽狂瀾，並客觀檢視其成敗得"
  },
  {
    "id": "book-9786264085731",
    "title": "量價分析大師威科夫的看盤法：成交放大就會漲？股價急拉就是趨勢？從逐筆成交到波段結構，看懂量能、節奏與價格痕跡",
    "subtitle": "市場不會先告訴你答案，但它會留下可以被檢查的痕跡！",
    "author": "[美]理查．D．威科夫（Richard D. Wyckoff）著 伊莉莎工作室 編譯",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "商業理財",
    "publishDate": "2026-10-28",
    "isbn": "9786264085731",
    "coverImage": "/assets/books/9786264085731.jpg",
    "summary": "市場不會先告訴你答案，但它會留下可以被檢查的痕跡！ 成交放大了，為什麼不一定代表行情會繼續上漲？ 股價突然急拉，是趨勢開始，還是少數成交造成的短暫波動？ 同樣上漲3％，為何有些股票容易判讀，有些卻可能讓人看錯？ ▎成交＋量能＋節奏，讀懂價格留下的痕跡 本書從威科夫盤勢判讀出發，把看盤重新拉回已經發生的事實：報價代表交易意願，真正完成的成交，才是可以回頭核對的紀錄。當成交依照時間排列，價格位置、移動距離、速度與交易密度，便會逐漸形成可閱讀的脈絡。 ▎價格走了多遠，不等於市場發生了多少事 兩檔股票即使都上漲3％，背後留下的交易紀錄也可能完全不同。交易活絡的股票，沿途會留下大量成交；交易清淡的股票，少數幾筆成交就可能帶動明顯價差。本書從成"
  },
  {
    "id": "book-9786264085717",
    "title": "金錢心理學，AI時代的財富焦慮與認知偏誤：風險思維×行為觀察×選擇自主，從衝動消費到投資判斷全面拆解，在資訊洪流中守住自己的判斷標準",
    "subtitle": "為什麼收入增加了，恐懼卻沒有減少？",
    "author": "劉燁",
    "brand": "財經錢線",
    "brandSlug": "finance-line",
    "category": "心理學",
    "publishDate": "2026-10-28",
    "isbn": "9786264085717",
    "coverImage": "/assets/books/9786264085717.jpg",
    "summary": "為什麼收入增加了，恐懼卻沒有減少？ 答案往往不在帳戶裡，而藏在我們看待金錢的方式裡 【金錢，從來不只是錢】 我們每天都在使用金錢，卻未必真正理解自己為什麼想賺錢、害怕沒錢，甚至被財富牽動情緒。從生存保障、安全感，到地位、尊重、自我實現，金錢早已滲入人生的各個層面。進入AI時代後，虛擬資產、智慧理財、演算法推薦與數位消費快速改變財富的形態，也放大了人們原有的焦慮、欲望與比較心理。本書從心理學、行為經濟學與社會觀察出發，重新拆解人與金錢之間最深層的關係。 【AI改變工具，也放大人性】 AI讓投資分析、消費決策、工作效率與財富管理變得更加便利，卻也帶來新的認知陷阱。AI造富神話、虛擬資產迷思、演算法攀比、數位消費衝動與職業替代焦慮，都可能"
  }
];
